import { useDispatch } from 'react-redux'

import { Box, CloseButton } from '@chakra-ui/react'

import { toggleIncidentTraceLogDrawer } from '@/redux/ui/uiSlice'

export const TraceLogHeader = () => {
  const dispatch = useDispatch()

  return (
    <Box
      alignItems='center'
      borderBottom='1px solid #D5DCE4'
      display='flex'
      h='65px'
      justifyContent='space-between'
      px='24px'
    >
      <Box color='black' fontSize='20px' fontWeight='extrabold'>
        Trace Logs
      </Box>
      <CloseButton
        ml={4}
        onClick={() => dispatch(toggleIncidentTraceLogDrawer())}
      />
    </Box>
  )
}
